import { createFileRoute } from "@tanstack/react-router";
import { Users } from "@/components/Users";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTabParam } from "@/hooks/useUrlParams";

const USERS_TABS = ["administrators", "users"] as const;
type UsersTab = (typeof USERS_TABS)[number];

function RouteComponent() {
  const [tab, setTab] = useTabParam<UsersTab>("tab", "administrators", USERS_TABS);

  // Each tab mounts its own Users, so search and filters start clean when switching.
  return (
    <Tabs value={tab} onValueChange={(next) => setTab(next as UsersTab)} className="min-w-0">
      <TabsList>
        <TabsTrigger value="administrators">Administrators</TabsTrigger>
        <TabsTrigger value="users">Users</TabsTrigger>
      </TabsList>
      <TabsContent value="administrators">
        <Users isAdmin />
      </TabsContent>
      <TabsContent value="users">
        <Users />
      </TabsContent>
    </Tabs>
  );
}

export const Route = createFileRoute("/_authenticated/users/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
